import { render, staticRenderFns } from "./FastFood.vue?vue&type=template&id=debc7bda&"
import script from "./FastFood.vue?vue&type=script&lang=js&"
export * from "./FastFood.vue?vue&type=script&lang=js&"
import style0 from "./FastFood.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports